import React from 'react';

import HoneyTable, { makeTargetService} from './HoneyTable.js'

function TopFlavours({topFlavours}) {
  return (
    <HoneyTable
      titleBefore="Top&nbsp;"
      titleHoney="Attacked"
      titleAfter="&nbsp;Services"
      fields={["TargetService", "Count"]}
      pagination={false}
      data={topFlavours}
      dataTransform={makeTargetService}
    />
  );
}

export default TopFlavours;
